export const getLinkWithQueryString = link => {
    if (typeof window !== 'undefined') {
        return `${link}${window.location.search}`;
    }

    return link;
}


// WEBPACK FOOTER //
// ./src/utils/urlTools.js